<template>
    <div id="global" > 
      <div id="your-container-element"></div>
      <!-- <div v-else id="confirmation">Order complete!</div> -->
    </div>
    </template> 
    <script>
    import { loadScript } from "@paypal/paypal-js";
    import Vue from 'vue'
    import {BusEmisor} from '../../../js/BusEmisor.js' 
    export default {
        props: {
            pay_id: {
            type: Number,
            default: null
          },
          cost: Number,
          billRequired: {
            type: Boolean,
            default: false,
          },
          billData: {
            type: Object,
            default: a => a,
          },
          plan: {
            type: String, 
          },
        },
        data() {
          return {  
    
          }
        }, 
        methods: { 
          loadS(){
            loadScript({ clientId: "AQsJmBtplxhlv0ioa70wXAb9xNguw_VaCOuM1UagSGlP_i5CDhbk1MVz6VVBd_ExVC6CWzSPDqQN4oEU", currency:"MXN", dataPageType: "checkout" })
              .then((paypal) => {
                  paypal
                      .Buttons({
                        createOrder: createOrder,
                        onApprove: onApprove,
                      })
                      .render("#your-container-element")
                      .catch((error) => {
                          console.error("failed to render the PayPal Buttons", error);
                      });
              })
              .catch((error) => {
                  console.error("failed to load the PayPal JS SDK script", error);
              });
          }, 
          // pagarPaypal(){
          //   let fd = new FormData()  
          //     fd.append('course_id', this.course_id)
    
          //     this.api.post('course/payment-efectivo', fd).then(({data}) => {   
          //       location.reload()
          //       console.log(data);
          //     }).catch(err => { 
          //      console.log(err);
          //     })
          // }
        },
        mounted(){ 
          this.loadS();
        },
        created() {
         Vue.prototype.pay = this.pay_id; 
         Vue.prototype.costo = this.cost; 
        }
    }
    
    // const   
    
       function createOrder(data, actions) {
          console.log('Creating order...')
          return actions.order.create({
            purchase_units: [
              {
                amount: {
                  value:  Vue.prototype.costo,
                },
              },
            ],
          })
        }
    
    function onApprove(data, actions) {
      console.log('Order approved...')
      return actions.order.capture().then(() => {
        // paid.value = true
        console.log('Order complete!') 
        let fd = new FormData()  
          fd.append('pay_id', Vue.prototype.pay)
    
          Vue.prototype.$http.post('https://api.kllaar.com/api/course/payment-paypal', fd).then(({data}) => {   
            // location.reload() 
            BusEmisor.$emit("payment_paypal2");
            console.log(data);
          }).catch(err => { 
            console.log(err);
          })
      })
    }
    </script>
    <style>
    #global {
        height: 70px;
        width: 100%;
        border: 1px solid #ddd;
        background: #fff;
        overflow-y: hidden;
        z-index: -1;
    }
    </style>


// WEBPACK FOOTER //
// src/components/#public/payments/CheckoutPayment2.vue